import React, { useEffect, useRef, useState } from "react";
import styles from './ProductCard.module.css';
import { useNavigate } from "react-router-dom";

export default function ProductCardV2({productGroupObj}){

    const navigate = useNavigate();

    const [mouseOver,setMouseOver] = useState(false);
    const [currentImg,setCurrentImg] = useState(0);
    const [width,setWidth] = useState(0);

    const card = useRef();

    const handleOpenProduct = () => {
        window.scrollTo(0,0);
        navigate(`/hiq/catalogue/${productGroupObj.productGroupCode}/${productGroupObj.sortedProductVariations[0].id}`);
    }

    const handleOpenProductSpecific = (id) => {
        window.scrollTo(0,0);
        navigate(`/hiq/catalogue/${productGroupObj.productGroupCode}/${id}`);
    }

    useEffect(() => {
        if(card.current){
            setWidth(card.current.clientWidth);
            console.log(productGroupObj.productGroupName,card.current.clientWidth)
        }
    },[card.current]);

    useEffect(() => {
        console.log(productGroupObj.productGroupName,card.current.clientWidth)
    },[mouseOver]);

    const optionDiv = (productVar) => {
        let imgUrl = '';
        if(productVar.imgUrl !== null && productVar.imgUrl !== ''){
            if(productVar.imgUrl.includes(',')){
                imgUrl = productVar.imgUrl.split(',')[0].replace('/s/','/shared/static/');
            } else {
                imgUrl = productVar.imgUrl.replace('/s/','/shared/static/');
            }
        }
        return (
            <div className={styles.optionDiv} onClick={() => handleOpenProductSpecific(productVar.id)}>
                <div className={styles.optionImg}>
                    <div className={styles.img} style={{backgroundImage: `url(${imgUrl})`}}/>
                </div>
                <p>{productVar.productVariant}</p>
                <p className={styles.viewElement}>View more</p>
            </div>
        )
    }

    return (
        <div className={styles.outerContainer} style={{color: '#000', height: `${Number(width)+Number(7.125*16)}px`}}>
            <div ref={card} className={`${styles.cardContainer} ${productGroupObj.noVariations > 1 ? styles.multiple : ''}`} onMouseEnter={() => setMouseOver(true)} onMouseLeave={() => setMouseOver(false)}>
                <div className={styles.imgContainer} style={{height: `${Number(width)}px`}} onClick={handleOpenProduct}>
                    {productGroupObj.imgArray.length > 0 ? productGroupObj.imgArray.map((img,index) => <div className={styles.imgDiv} style={{opacity: `${index === 0 && !mouseOver || index === currentImg && mouseOver? 1 : 0}`,transition: '0.3s',backgroundImage: `url(${img})`}}>
                    </div>) : 'No Image' }
                </div>
                <div className={styles.cardDetails} onClick={handleOpenProduct}>
                    <div>
                        <p className={styles.code}>{productGroupObj.productGroupCode}</p>
                        <h3>{productGroupObj.productGroupName}</h3>
                        <p className={styles.code}>{productGroupObj.noVariations > 1 ? productGroupObj.noVariations+' options' : productGroupObj.description}</p>
                    </div>
                    <p className={styles.cost}>{productGroupObj.noVariations > 1 ? 'from ' : ''}£{(productGroupObj.lowestCost).toFixed(2)}</p>
                </div>
                {/* <div className={styles.extraContainerCon}>
                    <div className={styles.extraContainer}>
                        {true && productGroupObj.noVariations > 1? productGroupObj.sortedProductVariations.map((productVar) => optionDiv(productVar)) : ''}
                    </div>
                </div> */}
            </div>
        </div>
    )
}